import React, { useState } from 'react';
import { Link, withRouter } from 'react-router-dom';

import { Table } from 'antd';
import { Col, Row, Dropdown, DropdownButton, Spinner } from 'react-bootstrap';
import 'react-bootstrap-table/dist/react-bootstrap-table.min.css';
import PreEFormHeader from '../../PreEForm/PreEFormHeader';
import { projectStatusCodeMap } from '../../../components/ProjectStatusCodeMap';
import { isViewOnlyOrExternalView } from '../../../utils/UserInfo';
import '../../../containers/startproj/startproj.css';
import ProgressBar from '../../common/progress_bar';
import EmptyView from '../../../components/EmptyView';
import './styles.css';
import PreCommentsIcon from '../../PreEForm/PreEFormFields/Comments/PreCommentsIcon';
import PreEFormEnergizedDialog from '../PreEFormEnergizedDialog';
import ReactTooltip from 'react-tooltip';
import {
  SearchAndDropdownComponent,
  commonSorter,
  composeFilters,
  searchAndDropDownFilters,
  searchAndDropDownOnFilters,
  commonFilter,
} from 'utils/AntdTableFunctions';

const leftAlignLabel = {
  style: {
    textAlign: 'left',
    fontWeight: 'bold',
  },
};

function PreEFormGrid(props) {
  const {
    allForms,
    project,
    onCreateForm,
    updateExceptionsState,
    onEditForm,
    onViewForm,
    onDeleteForm,
    onEnergizedStatus,
    onPdfForm,
    status,
    refreshPreEForms,
  } = props;
  const [showEnergizedModal, setShowEnergizedModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  function onActionMenuClick(row) {
    setSelectedRow(row);
  }

  function onViewActionClick(row) {
    onViewForm(row.id);
  }

  function onEditActionClick(row) {
    onEditForm(row.id);
  }

  function onDeleteActionClick(row) {
    onDeleteForm(row);
  }

  function onEnergizedUnEnergizedClick(row) {
    setShowEnergizedModal(true);
  }

  function onPdfActionClick(row) {
    onPdfForm(row.id);
  }

  const columns = [
    {
      dataIndex: 'actionsMenu',
      key: 'actionsMenu',

      title: 'Actions',
      render: (cellContent, row) => (
        <DropdownButton
          id={`${row.id}-dropdown`}
          title=''
          style={{
            width: '100%',
            position: 'inherit',
          }}
          onClick={() => onActionMenuClick(row)}
        >
          <Dropdown.Item onClick={() => onViewActionClick(row, cellContent)}>
            View
          </Dropdown.Item>
          {project.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            !isViewOnlyOrExternalView() &&
            row.energized === 'N' && (
              <Dropdown.Item onClick={() => onEditActionClick(row)}>
                Edit
              </Dropdown.Item>
            )}
          {project.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            !isViewOnlyOrExternalView() &&
            row.energized === 'N' && (
              <Dropdown.Item onClick={() => onDeleteActionClick(row)}>
                Delete
              </Dropdown.Item>
            )}
          {project.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            !isViewOnlyOrExternalView() &&
            row.energized === 'Y' && (
              <Dropdown.Item onClick={() => onEnergizedUnEnergizedClick(row)}>
                Undo Energized
              </Dropdown.Item>
            )}
          {project.projectStatus !== projectStatusCodeMap['CLOSED'] &&
            !isViewOnlyOrExternalView() &&
            row.energized === 'N' &&
            row.energizationStatus != 'P' && (
              <Dropdown.Item onClick={() => onEnergizedUnEnergizedClick(row)}>
                Energize
              </Dropdown.Item>
            )}
          <Dropdown.Item onClick={() => onPdfActionClick(row, cellContent)}>
            PDF Report
          </Dropdown.Item>
        </DropdownButton>
      ),

      align: 'center',
    },
    {
      dataIndex: 'formName',
      key: 'formName',
      title: 'Title',

      render: FormTitleFormatter,
      defaultSortOrder: 'ascend',
      filters: searchAndDropDownFilters('formName', allForms),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'formName'),

      sorter: (a, b) => commonSorter(a, b, 'formName'),
    },
    {
      dataIndex: 'preEnergizationDate',
      key: 'preEnergizationDate',
      title: 'Enrgz Date',

      filters: composeFilters('preEnergizationDate', allForms),

      onFilter: (value, record) =>
        commonFilter(value, record, 'preEnergizationDate'),

      sorter: (a, b) => commonSorter(a, b, 'preEnergizationDate'),

      align: 'center',
    },
    {
      dataField: 'reqSos',
      key: 'reqSos',
      title: 'REQ/SOS #',

      render: ReqFormatter,
      filters: searchAndDropDownFilters('reqSos', allForms),
      ...SearchAndDropdownComponent(),
      onFilter: (value, record) =>
        searchAndDropDownOnFilters(value, record, 'reqSos'),

      sorter: (a, b) => commonSorter(a, b, 'reqSos'),
    },
    {
      dataIndex: 'id',
      key: 'id',
      title: 'Enrgz Status',

      render: showEnergizationStatus,
      filters: composeFilters('energizationStatusDesc', allForms),

      onFilter: (value, record) =>
        commonFilter(value, record, 'energizationStatusDesc'),
      sorter: (a, b) => commonSorter(a, b, 'energizationStatusDesc'),

      align: 'center',
    },
    {
      dataIndex: 'assetCountMsg',
      key: 'assetCountMsg',
      title: 'Assets Assigned',

      filters: composeFilters('assetCount', allForms),

      onFilter: (value, record) => commonFilter(value, record, 'assetCount'),
      sorter: (a, b) => commonSorter(a, b, 'assetCount'),

      align: 'center',
    },
    {
      dataIndex: 'id',
      key: 'id',
      title: '% Complete',
      width: '10%',
      render: percentComplete,

      align: 'center',
    },
    {
      dataIndex: 'id',
      key: 'id',
      title: 'No of Exceptions',

      render: ExceptionsCellFormatter,

      align: 'center',
    },
    {
      dataIndex: 'comment',
      key: 'comment',
      title: 'Comments',

      render: CommentCellFormatter,

      align: 'center',
    },
  ];

  const getUnAssignedAssetCnt = () => {
    let r = 0;
    for (const form of allForms) r += form.assetCount;
    return project.noOfSectionAssets - r;
  };

  function showEnergizationStatus(cell, row) {
    return (
      <div>
        {row.energized === 'Y' ? 'Energized' : row.energizationStatusDesc}
      </div>
    );
  }

  function percentComplete(cell, row) {
    return row.pctComplete < 100 ? (
      <ProgressBar percentage={row.pctComplete} />
    ) : (
      <ProgressBar percentage={row.pctComplete} color={'success'} />
    );
  }

  function CommentCellFormatter(cell, preEForm) {
    //preEform is the row
    let props = { project, preEForm };
    return (
      <div style={{ display: 'inline-block' }}>
        <PreCommentsIcon {...props} />
      </div>
    );
  }

  function ExceptionsCellFormatter(cell, row) {
    if (row.exceptionsCount <= 0) {
      if (
        project.projectStatus === projectStatusCodeMap['CLOSED'] ||
        isViewOnlyOrExternalView() ||
        row.energized === 'Y'
      ) {
        return null;
      } else {
        return (
          <Link
            to={`/${status}/${project.id}/peform/${row.id}/exceptions`}
            onClick={() => updateExceptionsState(row.id)}
          >
            <strong id='createException' style={{ fontSize: 'large' }}>
              {' '}
              +{' '}
            </strong>
          </Link>
        );
      }
    } else {
      return (
        <Link
          to={`/${status}/${project.id}/peform/${row.id}/exceptions`}
          onClick={() => updateExceptionsState(row.id)}
        >
          <strong id='showException'>{row.exceptionsCount}</strong>
        </Link>
      );
    }
  }

  function FormTitleFormatter(cell, row) {
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Link to={`/${status}/${project.id}/peform/${row.id}/showTasks`}>
          <strong>{row.formName}</strong>
        </Link>
      </div>
    );
  }

  function ReqFormatter(cell, row) {
    let line1 = '';
    let line2 = '';
    let list = null;
    if (row.reqSos && row.reqSos.length > 1) {
      list = row.reqSos.split(',');
      line1 = list[0];
      //alert(line1);
      if (list.length > 1) {
        line2 = list[1];
      }
      if (list.length == 1) {
        return <div>{line1}</div>;
      } else if (list.length == 2) {
        return (
          <>
            <div>{line1}</div>
            <div>{line2}</div>
          </>
        );
      } else if (list.length > 2) {
        return (
          <>
            <div>{line1}</div>
            <div
              data-tip
              data-for={'toolTip-' + row.id}
              style={{ alignItems: 'left', width: 100 }}
            >
              {line2}...
            </div>
            <ReactTooltip
              id={'toolTip-' + row.id}
              place='bottom'
              effect='solid'
              textColor='black'
              backgroundColor='white'
              border={true}
              borderColor='black'
              type='info'
            >
              {getReqList(list)}
            </ReactTooltip>
          </>
        );
      }
    } else {
      return <p>{row.reqSos}</p>;
    }
  }
  const getReqList = (list) => {
    return list.map((desc, index) => <div>{desc}</div>);
  };

  const NoDataIndication = () =>
    refreshPreEForms ? (
      <Spinner animation='border' variant='primary' />
    ) : (
      <EmptyView />
    );

  return (
    <div>
      <Row
        className='justify-content-middle'
        style={{
          alignItems: 'center',
          justifyContent: 'center',
          fontStyle: 'italic',
          fontWeight: 'bold',
          marginBottom: 12,
        }}
      >
        <i
          class='fa fa-info-circle'
          style={{ color: 'red', paddingRight: '3px' }}
          aria-hidden='true'
        ></i>{' '}
        Note: The % Calculations on this tab include tasks Signed, Marked N/A,
        and those Marked Temp.
      </Row>
      <Row className='justify-content-middle'>
        <Col className='justify-content-middle'>
          <Col className='justify-content-middle'>
            <b>
              Assets Not Yet Assigned to a Pre-E Form: {getUnAssignedAssetCnt()}{' '}
              of {project.noOfSectionAssets}
            </b>
          </Col>
          <Col className='justify-content-middle'>
            <b>Pre-Job Tasks: {project.preJobTPercent}% Complete</b>
          </Col>
          {project.showSecurityTasks === 1 && (
            <Col className='justify-content-middle'>
              <b>CIP Security Tasks: {project.cipsecurityTPercent}% Complete</b>
            </Col>
          )}
        </Col>
        <Col className='justify-content-middle'>
          {!isViewOnlyOrExternalView() && (
            <PreEFormHeader
              onCreateForm={onCreateForm}
              renderCreate={
                project.projectStatus !== projectStatusCodeMap['CLOSED']
              }
              {...leftAlignLabel}
            />
          )}
        </Col>
      </Row>

      <div className='antd-table-custom-css pre-form '>
        <Table
          columns={columns}
          dataSource={allForms}
          pagination={false}
          locale={{
            emptyText: <NoDataIndication />,
          }}
        />
      </div>
      <br />
      {showEnergizedModal && (
        <PreEFormEnergizedDialog
          handleOk={onEnergizedStatus}
          handleCancel={setShowEnergizedModal}
          row={selectedRow}
        />
      )}
    </div>
  );
}

export default withRouter(PreEFormGrid);
